export const ADDON_ID = 'addon-apolloClient';
export const PARAM_KEY = 'apolloClient';
export const NAME = 'ApolloClient';
//# sourceMappingURL=constants.js.map